import React, { Component } from 'react';
import {BASE_PATH, STATUS_NAME} from "../../../../../wpconfig";
import {NavLink} from "react-router-dom";

class Item extends Component {
  constructor(props) {
    super(props);
  }

  tolinkDetail = (event) => {
    const t = window.location.href.split("?")[1].replace(/[\?&]record_id=[^&]+/, '')
    return BASE_PATH + "wp-admin/admin.php?" + t + "&record_id=" + this.props.record.scholar_id;
  }

  copy = (e) => {
    const textarea = document.createElement("textarea");
    textarea.value = this.props.record.scholar_id;
    textarea.style.top = 0;
    textarea.style.left = 0;
    textarea.style.position = "fixed";

    // 흐름 3.
    document.body.appendChild(textarea);
    // focus() -> 사파리 브라우저 서포팅
    textarea.focus();
    // select() -> 사용자가 입력한 내용을 영역을 설정할 때 필요
    textarea.select();
    // 흐름 4.
    document.execCommand("copy");
    // 흐름 5.
    document.body.removeChild(textarea);
    alert("클립보드에 복사되었습니다.");
  }

  render() {
    const record = this.props.record;
    // console.log(this.props)
    // console.log(record)
    // console.log(window.location.href.split("?")[1])
    return (
      <tr>
        <td>{this.props.no}</td>
        <td>
          <NavLink to={this.tolinkDetail}>{record.scholar_name}</NavLink> -
          <svg
            onClick={this.copy}
            ref={(ref)=>this.textInput=ref}
            xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
               className="bi bi-arrow-up-left-square" viewBox="0 0 16 16">
            <path fillRule="evenodd"
                  d="M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm10.096 8.803a.5.5 0 1 0 .707-.707L6.707 6h2.768a.5.5 0 1 0 0-1H5.5a.5.5 0 0 0-.5.5v3.975a.5.5 0 0 0 1 0V6.707l4.096 4.096z"/>
          </svg>
        </td>
        <td>
          {!record.scholar_status ? <span className="badge badge-item-status bg-danger">확인필요</span>
            : record.scholar_status === 'publish' ? <span className="badge badge-item-status badge-success">{STATUS_NAME[record.scholar_status]}</span>
              : record.scholar_status === 'draft' ? <span className="badge badge-item-status badge-warning">{STATUS_NAME[record.scholar_status]}</span>
                : record.scholar_status === 'trash' ? <span className="badge badge-item-status badge-dark">{STATUS_NAME[record.scholar_status]}</span>
                  : record.scholar_status === 'unpublish' ? <span className="badge badge-item-status badge-secondary">{STATUS_NAME[record.scholar_status]}</span>
                    : ''
          }
        </td>
      </tr>
    )
  }
}

export default Item;